import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchSpinnerContent } from '../../store/slice/spinner';

const SpinnerInitializer = () => {
  const dispatch = useDispatch();
  const { status } = useSelector((state) => state.spinner);

  useEffect(() => {
    if (status === 'idle') {
      dispatch(fetchSpinnerContent());
    }
  }, [dispatch, status]);

  return null;
};

export default SpinnerInitializer;
